(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('searchPage', () => ({
      isLoading: false,
      searchQuery: '',
      searchResult: false,
      nextPageCount: 1,
      hasNextPage: false,
      init() {
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');

        this.getHasNextPage(document, page || this.nextPageCount);

        window.onpopstate = () => {
          window.location.reload();
        };
      },
      addNextPageItems(items) {
        const collectionItemsGrid = document.getElementById('coll-grid');
        items.forEach((item) => {
          collectionItemsGrid.append(item);
        });
      },
      getHasNextPage(node, counter = 1) {
        this.nextPageCount = counter;
        this.hasNextPage = !!node.querySelector('[data-next-page]');
      },
      getNewItems(response) {
        return response.querySelectorAll('#coll-grid article');
      },
      scrollToAnchor(node) {
        const anchorBlock = node;

        if (anchorBlock) {
          const elementPosition = anchorBlock.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition +
            window.pageYOffset -
            parseFloat(document.documentElement.style.getPropertyValue('--header-height') || 0);

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      },
      changeUrl(url) {
        window.history.pushState({}, url, url);
      },
      async renderSearch() {
        this.isLoading = true;
        this.resultsCount = 0;

        const url = `/search?q=${this.searchQuery}&type=product`;
        this.changeUrl(url);

        try {
          if (!this.searchQuery.length) {
            this.searchResult = false;
            this.isLoading = false;
            return;
          }

          const currentLayout = document.getElementById(`main-search`);

          const response = await this.get(url, { responseType: 'document' });
          const newLayout = response.getElementById(`main-search`);

          if (newLayout) {
            currentLayout.outerHTML = newLayout.outerHTML;
          }

          this.searchResult = true;
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
        }
      },
      async get(url, config = {}) {
        try {
          const options = Object.assign(
            {
              method: 'GET',
              headers: config.headers || {},
            },
            config,
          );

          const response = await fetch(url, options);

          if (!response.ok) {
            throw new Error(`Fetch error: ${response.status} ${response.statusText}`);
          }

          const text = await response.text();
          return new DOMParser().parseFromString(text, 'text/html');
        } catch (e) {
          console.log(e);
        }
      },
      async loadMore(newURL) {
        this.isLoading = true;

        try {
          const response = await this.get(newURL, { responseType: 'document' });

          const newItems = this.getNewItems(response);
          if (newItems && newItems.length) {
            this.addNextPageItems(newItems);
            this.isLoading = false;
          }

          this.getHasNextPage(response, this.nextPageCount);

          this.isLoading = false;
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
      },
      async loadMoreProducts() {
        this.nextPageCount++;

        const newURL =
          window.location.href.split('?').shift() +
          '?q=' +
          this.searchQuery +
          '&type=product&page=' +
          this.nextPageCount;
        await this.loadMore(newURL);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
